import { useMemo } from 'react';
import utils from 'utils';

const domainCountryCode = utils.config.getDomainCountry();

const useOCIProfileInitialValues = (profile, secondaryEmail = '', secondaryPhone = '', expeditedFlow = false) =>
  useMemo(() => {
    const { license_profile, address_profile, contact_profile, profile_found } = profile || {};

    return {
      license_info: {
        country_code: license_profile?.country_code || domainCountryCode,
        country_subdivision_code: license_profile?.country_subdivision_code,
        license_number: license_profile?.license_number,
        issuing_authority: license_profile?.issuing_authority,
      },
      license_expiration_date: utils.gmi.parseGBODate(license_profile?.license_expiration_date),
      license_issue_date: utils.gmi.parseGBODate(license_profile?.license_issue_date),
      birth_date: utils.gmi.parseGBODate(license_profile?.birth_date),
      address_info: {
        country_code: address_profile?.country_code || license_profile?.country_code || domainCountryCode,
        country_subdivision_code: address_profile?.country_subdivision_code,
        address_line_1: address_profile?.street_addresses?.[0],
        address_line_2: address_profile?.street_addresses?.[1],
        city: address_profile?.city,
        postal: address_profile?.postal,
      },
      contact_info: {
        phone_set: (contact_profile?.phones.length > 0 && contact_profile.phones) || [
          { phone_number: profile_found || expeditedFlow ? secondaryPhone : '' },
        ],
        email: contact_profile?.email || secondaryEmail,
      },
    };
  }, [profile?.license_profile, profile?.address_profile, profile?.contact_profile]);

export default useOCIProfileInitialValues;
